<div class="pt-3 pl-md-4 mb-6">

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin">
        Admin
      </a></li>
      <li class="breadcrumb-item"><a routerLink="/gifting-config">
        Gift Center
      </a></li>
      <li class="breadcrumb-item active" aria-current="page">
        Gift Discounts
      </li>
    </ol>
  </nav>

  <h2>Gift Discounts</h2>

  <p>
    Regular discounts do not apply when a product is purchased as a gift. Instead, use gift discounts to offer promotional rates on gifts.
  </p>

  <h2 *ngIf="serverError !== null">
    Server Error: {{ serverError }}
  </h2>

  <ng-container *ngIf="serverError === null">

    <div class="alert my-3" role="alert"
       [class.alert-success]="history.state.feedback.status == 'success'"
       [class.alert-info]="history.state.feedback.status == 'info'"
       *ngIf="history && history.state && history.state.feedback">
      {{ history.state.feedback.text }}
    </div>

    <div class="mb-4">

      <div class="float-right">
        <a class="btn btn-success"
           routerLink="/gifting-config/discounts/membership/add">
          Add Membership Gift Discount
        </a>
      </div>

      <h3>Membership Gift Discounts <span *ngIf="loadingMembershipGiftDiscounts" class="text-secondary">- Loading...</span></h3>

      <div class="rounded-table-wrapper table-responsive-lg mb-2">
        <table class="table table-hover">

          <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">Code</th>
            <th scope="col">Name</th>
            <th scope="col">Amount</th>
            <th scope="col">Start Date</th>
            <th scope="col">End Date</th>
            <th scope="col">Memberships</th>
          </tr>
          </thead>

          <tbody *ngIf="membershipGiftDiscountResultsPresent()">
          <tr *ngFor="let discount of membershipGiftDiscountsList"
              style="cursor: pointer"
              routerLink="/gifting-config/discounts/membership/{{ discount.id }}">
            <td>{{ discount.is_automatic ? 'Automatic' : 'Code' }}</td>
            <td>
              <span *ngIf="discount.code">{{ discount.code }}</span>
              <span *ngIf="!discount.code" class="text-muted">None</span>
            </td>
            <td>
              <span *ngIf="discount.name">{{ discount.name }}</span>
              <span *ngIf="!discount.name" class="text-muted">None</span>
            </td>
            <td>
              <span *ngIf="discount.discount_type === MembershipGiftDiscountType.currency">
                {{ orgConfig.formatCurrency(discount.amount) }}
              </span>
              <span *ngIf="discount.discount_type === MembershipGiftDiscountType.percentage">
                {{ discount.amount }}%
              </span>
            </td>
            <td>
              <span *ngIf="discount.start_date">{{ dateStringFromISO8601(discount.start_date) }}</span>
              <span *ngIf="!discount.start_date" class="text-muted">None</span>
            </td>
            <td>
              <span *ngIf="discount.end_date">{{ dateStringFromISO8601(discount.end_date) }}</span>
              <span *ngIf="!discount.end_date" class="text-muted">None</span>
            </td>
            <td>
              <span *ngIf="discount.membership_names.length === 1">1 membership</span>
              <span *ngIf="discount.membership_names.length !== 1">{{ discount.membership_names.length }} memberships</span>
              <ng-container *ngFor="let itemName of discount.membership_names.slice(0, 5)">
                <br>
                <i>{{ itemName }}</i>
              </ng-container>
              <ng-container *ngIf="discount.membership_names.length > 5">
                <br>
                <i>&#8230;</i>
              </ng-container>
            </td>
          </tr>
          </tbody>

          <tbody *ngIf="!membershipGiftDiscountResultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingMembershipGiftDiscounts ? 'Loading...' : 'No membership gift discounts configured' }}
            </td>
          </tr>
          </tbody>

        </table>
      </div>

      <a class="btn btn-success" routerLink="/gifting-config/discounts/membership/add">
        Add Membership Gift Discount
      </a>

    </div>

    <div class="mb-4">

      <div class="float-right">
        <a class="btn btn-success"
           routerLink="/gifting-config/discounts/entry-pass/add">
          Add Entry Pass Gift Discount
        </a>
      </div>

      <h3>Entry Pass Gift Discounts <span *ngIf="loadingEntryPassGiftDiscounts" class="text-secondary">- Loading...</span></h3>

      <div class="rounded-table-wrapper table-responsive-lg mb-2">
        <table class="table table-hover">

          <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">Code</th>
            <th scope="col">Name</th>
            <th scope="col">Amount</th>
            <th scope="col">Start Date</th>
            <th scope="col">End Date</th>
            <th scope="col">Entry Passes</th>
          </tr>
          </thead>

          <tbody *ngIf="entryPassGiftDiscountResultsPresent()">
          <tr *ngFor="let discount of entryPassGiftDiscountsList"
              style="cursor: pointer"
              routerLink="/gifting-config/discounts/entry-pass/{{ discount.id }}">
            <td>{{ discount.is_automatic ? 'Automatic' : 'Code' }}</td>
            <td>
              <span *ngIf="discount.code">{{ discount.code }}</span>
              <span *ngIf="!discount.code" class="text-muted">None</span>
            </td>
            <td>
              <span *ngIf="discount.name">{{ discount.name }}</span>
              <span *ngIf="!discount.name" class="text-muted">None</span>
            </td>
            <td>
              <span *ngIf="discount.discount_type === EntryPassGiftDiscountType.currency">
                {{ orgConfig.formatCurrency(discount.amount) }}
              </span>
              <span *ngIf="discount.discount_type === EntryPassGiftDiscountType.percentage">
                {{ discount.amount }}%
              </span>
            </td>
            <td>
              <span *ngIf="discount.start_date">{{ dateStringFromISO8601(discount.start_date) }}</span>
              <span *ngIf="!discount.start_date" class="text-muted">None</span>
            </td>
            <td>
              <span *ngIf="discount.end_date">{{ dateStringFromISO8601(discount.end_date) }}</span>
              <span *ngIf="!discount.end_date" class="text-muted">None</span>
            </td>
            <td>
              <span *ngIf="discount.entry_pass_names.length === 1">1 pass</span>
              <span *ngIf="discount.entry_pass_names.length !== 1">{{ discount.entry_pass_names.length }} passes</span>
              <ng-container *ngFor="let itemName of discount.entry_pass_names.slice(0, 5)">
                <br>
                <i>{{ itemName }}</i>
              </ng-container>
              <ng-container *ngIf="discount.entry_pass_names.length > 5">
                <br>
                <i>&#8230;</i>
              </ng-container>
            </td>
          </tr>
          </tbody>

          <tbody *ngIf="!entryPassGiftDiscountResultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingEntryPassGiftDiscounts ? 'Loading...' : 'No entry pass gift discounts configured' }}
            </td>
          </tr>
          </tbody>

        </table>
      </div>

      <a class="btn btn-success" routerLink="/gifting-config/discounts/entry-pass/add">
        Add Entry Pass Gift Discount
      </a>

    </div>

    <div class="mb-4">

      <div class="float-right">
        <a class="btn btn-success"
           routerLink="/gifting-config/discounts/voucher-pack/add">
          Add Voucher Pack Gift Discount
        </a>
      </div>

      <h3>Voucher Pack Gift Discounts <span *ngIf="loadingVoucherPackGiftDiscounts" class="text-secondary">- Loading...</span></h3>

      <div class="rounded-table-wrapper table-responsive-lg mb-2">
        <table class="table table-hover">

          <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">Code</th>
            <th scope="col">Name</th>
            <th scope="col">Amount</th>
            <th scope="col">Start Date</th>
            <th scope="col">End Date</th>
            <th scope="col">Voucher Packs</th>
          </tr>
          </thead>

          <tbody *ngIf="voucherPackGiftDiscountResultsPresent()">
          <tr *ngFor="let discount of voucherPackGiftDiscountsList"
              style="cursor: pointer"
              routerLink="/gifting-config/discounts/voucher-pack/{{ discount.id }}">
            <td>{{ discount.is_automatic ? 'Automatic' : 'Code' }}</td>
            <td>
              <span *ngIf="discount.code">{{ discount.code }}</span>
              <span *ngIf="!discount.code" class="text-muted">None</span>
            </td>
            <td>
              <span *ngIf="discount.name">{{ discount.name }}</span>
              <span *ngIf="!discount.name" class="text-muted">None</span>
            </td>
            <td>
              <span *ngIf="discount.discount_type === VoucherPackGiftDiscountType.currency">
                {{ orgConfig.formatCurrency(discount.amount) }}
              </span>
              <span *ngIf="discount.discount_type === VoucherPackGiftDiscountType.percentage">
                {{ discount.amount }}%
              </span>
            </td>
            <td>
              <span *ngIf="discount.start_date">{{ dateStringFromISO8601(discount.start_date) }}</span>
              <span *ngIf="!discount.start_date" class="text-muted">None</span>
            </td>
            <td>
              <span *ngIf="discount.end_date">{{ dateStringFromISO8601(discount.end_date) }}</span>
              <span *ngIf="!discount.end_date" class="text-muted">None</span>
            </td>
            <td>
              <span *ngIf="discount.voucher_pack_names.length === 1">1 voucher pack</span>
              <span *ngIf="discount.voucher_pack_names.length !== 1">{{ discount.voucher_pack_names.length }} voucher packs</span>
              <ng-container *ngFor="let itemName of discount.voucher_pack_names.slice(0, 5)">
                <br>
                <i>{{ itemName }}</i>
              </ng-container>
              <ng-container *ngIf="discount.voucher_pack_names.length > 5">
                <br>
                <i>&#8230;</i>
              </ng-container>
            </td>
          </tr>
          </tbody>

          <tbody *ngIf="!voucherPackGiftDiscountResultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingVoucherPackGiftDiscounts ? 'Loading...' : 'No voucher pack gift discounts configured' }}
            </td>
          </tr>
          </tbody>

        </table>
      </div>

      <a class="btn btn-success" routerLink="/gifting-config/discounts/voucher-pack/add">
        Add Voucher Pack Gift Discount
      </a>

    </div>

  </ng-container>

</div>
